__turbopack_context__.v({
  "caption": "StatTile-module__6PC1uW__caption",
  "delta": "StatTile-module__6PC1uW__delta",
  "footer": "StatTile-module__6PC1uW__footer",
  "label": "StatTile-module__6PC1uW__label",
  "tile": "StatTile-module__6PC1uW__tile",
  "value": "StatTile-module__6PC1uW__value",
});
